var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_255dc3ea"]},_vm.$listeners),[_c('cube-button',{attrs:{"outline":"","primary":"","disabled":""}},[_vm._v("outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }